import { render, staticRenderFns } from "./BasMaterialList.vue?vue&type=template&id=541dba60&scoped=true&"
import script from "./BasMaterialList.vue?vue&type=script&lang=js&"
export * from "./BasMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./BasMaterialList.vue?vue&type=style&index=0&id=541dba60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541dba60",
  null
  
)

export default component.exports